(() => {
  function setup(scope = document) {
    scope.querySelectorAll('.bn-stock-form').forEach(form => {
      if (form.dataset.stockReady) return;
      const config = form.querySelector('[data-stock-config]');
      if (!config) return;
      form.dataset.stockReady = 'true';
      form.noValidate = true;
      const data = JSON.parse(config.textContent);
      const variantInput = form.querySelector('[name="id"]');
      const quantity = form.querySelector('[name="quantity"]');
      const note = form.querySelector('[data-stock-note]');
      const button = form.querySelector('[type="submit"]');
      let validating = false;
      let approved = false;
      let attempted = false;
      if (variantInput.tagName === 'SELECT' && window.BNSizes) {
        const selectedId = variantInput.value;
        [...variantInput.options].sort((a, b) => window.BNSizes.compare(data.variants[a.value].title, data.variants[b.value].title)).forEach(option => variantInput.append(option));
        variantInput.value = selectedId;
      }
      const selected = () => data.variants[variantInput.value];
      const remaining = variant => variant.tracked ? Math.max(0, variant.stock - variant.inCart) : Infinity;
      function update() {
        const variant = selected();
        if (!variant) return false;
        const max = remaining(variant), entered = quantity ? Number(quantity.value) : 1;
        const blocked = !variant.available || max === 0;
        const invalid = !Number.isInteger(entered) || entered < 1 || entered > max;
        let message = '';
        if (attempted && invalid) {
          message = entered > max ? data.messages.maximum.replace('__count__', max) : data.messages.integer;
          if (entered > max && variant.inCart) message += ' ' + data.messages.in_cart.replace('__count__', variant.inCart);
         } else if (blocked) message = variant.inCart ? data.messages.in_cart.replace('__count__',variant.inCart) : data.messages.sold;
        else if (variant.tracked) {
          message = (max === 1 ? (data.messages.one || data.messages.many.replace('__count__',max)) : data.messages.many.replace('__count__',max));
          if (!data.defaultVariant && data.messages.size) message += ' ' + data.messages.size.replace('__size__',variant.title);
          if (variant.inCart) message += '. ' + data.messages.in_cart.replace('__count__',variant.inCart);
        }
        const price = form.closest('.product-info')?.querySelector('[data-variant-price]');
        if (price && variant.priceFormatted) {
          if (variant.promotional) {
            const original = document.createElement('s');
            original.className = 'bn-price-original';
            original.textContent = variant.originalPriceFormatted;
            const final = document.createElement('strong');
            final.className = 'bn-price-final';
            final.textContent = variant.priceFormatted;
            price.replaceChildren(original, document.createTextNode(' '), final);
          } else price.textContent = variant.priceFormatted;
        }
        note.textContent = message;
        note.dataset.limit = String(attempted && invalid);
        if (quantity) {
          if (variant.tracked) quantity.max = String(max);
          else quantity.removeAttribute('max');
          quantity.classList.toggle('bn-quantity-error', attempted && invalid);
          quantity.setAttribute('aria-invalid', String(attempted && invalid));
        }
        button.disabled = blocked || validating;
        return !blocked && !invalid;
      }
      variantInput.addEventListener('change', () => { attempted = false; if (quantity) quantity.value = '1'; update(); });
      quantity?.addEventListener('input', () => { attempted = true; update(); });
      quantity?.addEventListener('change', () => { attempted = true; update(); });
      async function refreshCart() {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart.js', {cache: 'no-store', headers: {Accept: 'application/json'}});
        if (!response.ok) throw new Error('Cart unavailable');
        const cart = await response.json();
        Object.entries(data.variants).forEach(([id, variant]) => {
          variant.inCart = cart.items.reduce((sum, item) => sum + (String(item.variant_id) === id ? item.quantity : 0), 0);
        });
      }
      form.addEventListener('submit', async event => {
        if (approved) {
          approved = false;
          if (!document.querySelector('[data-bn-bag]') || !window.HTMLDialogElement) return;
          event.preventDefault();
          validating = true;
          update();
          try {
            const root = window.Shopify?.routes?.root || '/';
            const response = await fetch(root + 'cart/add.js', {method:'POST', headers:{Accept:'application/json'}, body:new FormData(form)});
            const result = await response.json();
            if (!response.ok) throw new Error(result.description || data.messages.retry);
            try { await refreshCart(); update(); } catch (_) {}
            document.dispatchEvent(new CustomEvent('bn:cart-added'));
          } catch (error) { note.textContent = error.message || data.messages.retry; }
          finally { validating = false; button.disabled = !selected()?.available || remaining(selected()) === 0; }
          return;
        }
        event.preventDefault();
        if (validating) return;
        attempted = true;
        if (!update()) { quantity?.focus(); return; }
        validating = true;
        const requestedId = variantInput.value;
        update();
        try { await refreshCart(); } catch (_) {
          validating = false;
          update();
          note.textContent = data.messages.retry;
          return;
        }
        validating = false;
        if (!update() || variantInput.value !== requestedId) { quantity?.focus(); return; }
        approved = true;
        form.requestSubmit(button);
      });
      document.addEventListener('bn:cart-changed', () => { refreshCart().then(update).catch(() => {}); });
      window.addEventListener('pageshow', () => { refreshCart().then(update).catch(() => {}); });
      window.addEventListener('focus', () => { refreshCart().then(update).catch(() => {}); });
      note.tabIndex = -1;
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup());
  else setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
